import apiClient from './client';
import { ApiResponse } from '../types/api.types';
import { Game, CreateGameRequest, UpdateGameSettingsRequest } from '../types/game.types';

export const gamesApi = {
  createGame: async (data: CreateGameRequest): Promise<ApiResponse<{ game: Game; apiKey: string }>> => {
    return apiClient.post('/api/v1/games/create', data);
  },

  getGames: async (): Promise<ApiResponse<Game[]>> => {
    return apiClient.get('/api/v1/games');
  },

  getGame: async (gameId: string): Promise<ApiResponse<Game>> => {
    const res = await apiClient.get<ApiResponse<any>>(`/api/v1/games/${gameId}`);
    const g = res.data || {};

    const normalized: Game = {
      _id: g._id ?? g.gameId ?? gameId,
      bundleId: g.bundleId,
      name: g.name,
      settings: g.settings,
      adjustConfig: g.adjustConfig,
      createdAt: g.createdAt,
      updatedAt: g.updatedAt,
    };

    return { ...res, data: normalized };
  },

  updateGameSettings: async (gameId: string, data: UpdateGameSettingsRequest): Promise<ApiResponse<Game>> => {
    return apiClient.put(`/api/v1/games/${gameId}/settings`, data);
  },

  regenerateApiKey: async (gameId: string): Promise<ApiResponse<{ apiKey: string }>> => {
    return apiClient.post(`/api/v1/games/${gameId}/regenerate-key`);
  },

  deleteGame: async (gameId: string): Promise<ApiResponse<null>> => {
    return apiClient.delete(`/api/v1/games/${gameId}`);
  },
};